import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-animal-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.26 15C15.26 14.0054 14.8649 13.0516 14.1617 12.3483C13.4584 11.6451 12.5046 11.25 11.51 11.25C10.5154 11.25 9.56162 11.6451 8.85836 12.3483C8.1551 13.0516 7.76001 14.0054 7.76001 15C6.96436 15 6.2013 15.3161 5.63869 15.8787C5.07608 16.4413 4.76001 17.2044 4.76001 18C4.76001 18.7956 5.07608 19.5587 5.63869 20.1213C6.2013 20.6839 6.96436 21 7.76001 21C8.4206 20.9845 9.06819 20.8132 9.65001 20.5C10.2244 20.2014 10.8622 20.0455 11.5095 20.0455C12.1568 20.0455 12.7947 20.2014 13.369 20.5C13.9512 20.8132 14.5991 20.9845 15.26 21C16.0557 21 16.8187 20.6839 17.3813 20.1213C17.9439 19.5587 18.26 18.7956 18.26 18C18.26 17.2044 17.9439 16.4413 17.3813 15.8787C16.8187 15.3161 16.0557 15 15.26 15Z"
        [attr.stroke]="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.26001 13.5C4.50265 13.5 5.51001 12.4926 5.51001 11.25C5.51001 10.0074 4.50265 9 3.26001 9C2.01737 9 1.01001 10.0074 1.01001 11.25C1.01001 12.4926 2.01737 13.5 3.26001 13.5Z"
        [attr.stroke]="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.76001 7.5C9.00265 7.5 10.01 6.49264 10.01 5.25C10.01 4.00736 9.00265 3 7.76001 3C6.51737 3 5.51001 4.00736 5.51001 5.25C5.51001 6.49264 6.51737 7.5 7.76001 7.5Z"
        stroke="#00D5D3"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.26 7.5C16.5027 7.5 17.51 6.49264 17.51 5.25C17.51 4.00736 16.5027 3 15.26 3C14.0174 3 13.01 4.00736 13.01 5.25C13.01 6.49264 14.0174 7.5 15.26 7.5Z"
        [attr.stroke]="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.51 13.5C21.7527 13.5 22.76 12.4926 22.76 11.25C22.76 10.0074 21.7527 9 20.51 9C19.2674 9 18.26 10.0074 18.26 11.25C18.26 12.4926 19.2674 13.5 20.51 13.5Z"
        [attr.stroke]="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
})
export class AnimalInsuranceIconComponent extends BaseIconComponent {}
